import React from 'react';
import PropTypes from 'prop-types';

function PrettyJson(props) {
   const {nombreCampoId, objeto} = props;
   const {[nombreCampoId]: campoId, ...otrosCampos} = objeto;
   return (
      <div>
         {campoId && (
            <>
               {campoId}
               {Object.keys(otrosCampos).length > 0 && ':'}
               <br />
            </>
         )}
         <pre>
            {JSON.stringify(otrosCampos, null, 2)
               .replace(/\"|,?(?=\r?\n|\r)|{|}|\[|\]/g, '')
               .replace(/^\s*[\r\n]/gm, '')}
         </pre>
      </div>
   );
}

PrettyJson.propTypes = {
   /**Nombre del campo con el identificador del objeto. */
   nombreCampoId: PropTypes.string,
   objeto: PropTypes.object.isRequired
};

PrettyJson.defaultProps = {
   nombreCampoId: 'foo0',
   objeto: {
      foo0: 'foo0 valor',
      foo1: 'foo1 valor',
      foo2: 'foo2 valor',
      foo3: {
         cadena: 'foo anidado',
         array: [1, {objeto: 'nombre objeto'}, 3],
         objeto: {
            name: 'otro anidado'
         },
         numero: 50
      }
   }
};

export default PrettyJson;
